let activeSignup = Promise.resolve();

/**
 * Creating a Firebase auth user fires the auth listener before the sign-up flow has written the user's
 * Firestore profile. The listener waits on this so it never reads (or creates) a half-built profile.
 * Returns an idempotent `finish` function.
 */
export const beginSignup = () => {
	let finish;
	activeSignup = new Promise((resolve) => {
		finish = resolve;
	});
	return finish;
};

export const waitForActiveSignup = () => activeSignup;
